module.exports = __webpack_public_path__ + "static/media/Паспорт на Галеон серии S.b369a8c2.pdf";